
    var riot = require('riot')
    //src: starling/src/tags/drawings.html
riot.tag2('drawings',
  '<drawing each="{getDrawings()}" canvas="{parent.opts.canvas}"></drawing>',
  '',
  '', function(opts) {
'use strict';

var _drawingUi = require('lib/drawing-ui');

var _opts = opts,
    canvas = _opts.canvas;
var store = canvas.store;

canvas.drawingsTag = this;

this.getDrawings = function () {
  return store.getDrawings();
};

this.on('mount', function () {
  _drawingUi.drawingUI.setupDragging();
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('drawings')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/drawings.html
// module id = 809
// module chunks = 0